import React from "react";


const Imageheader = (props) => {
    return (
        <div className="col-12 p-0">
            <img className="img-fluid w-100 heading-image"
                 src={props.imageUrl}/>
            <div
                style={{
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'rgba(0,0,0,.4)',
                    fontSize: 'calc(1.5em + 2.5vw)',
                    fontWeight: 'bold',
                    color: 'white',
                    fontFamily: 'Calibri, sans-serif'
                }}>
                <div style={{
                    position: 'relative',
                    left: '2%',
                    width: '98%'
                }}>{props.isSpanish ? props.spanishText : props.englishText}</div>

            </div>
        </div>
    )
}

export default Imageheader;